import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Row, Typography, Divider, message, Input, Radio } from "antd";
import {
    DownOutlined,
    MailOutlined,
    MobileOutlined,
    SendOutlined,
    UpOutlined,
    WhatsAppOutlined
   } from '@ant-design/icons';
import { getTextOfTicket } from "./open-booked-ticket-modal.component";
import { checkActionAllowed, getWhatsAppMessage, isValid, isValidArray } from "../../utils/utilities";
import { ACTION_TICKET_NOTIFY_BTN } from "../../utils/constant";
import { useDispatch } from "react-redux";
import { loadingAction } from "../../actions/loading-actions";
import { getSmsTemplates, sendSms } from "../../actions/notify.actions";
import { getDateMonthYearInReadable } from "../../utils/date.utils";
import { fetchTicketDetailsByPNR } from "../../actions/ticket.action";
import { DeviceContext } from "../device-provider/device-provider";
const { Text } = Typography;

const getEmailEnabled = (selectedOption) => {
    return selectedOption === 'ticketDetails' ;
}   

const getWhatsAppEnabled = (selectedOption,pnrs) => {
    return selectedOption === 'ticketDetails' && isValidArray(pnrs) && pnrs.length === 1;
}   

export const NotifyButton = (props) => {
    const { onClick, showDownArrow=true, disabled=false, label="Notify", className="" } = props;

    if(!checkActionAllowed(ACTION_TICKET_NOTIFY_BTN)){
        return null;
    }

    return (
        <div>
            <Button onClick={onClick} disabled={disabled} className={className}>
                <SendOutlined /> {label} {showDownArrow && <DownOutlined />}
            </Button>
        </div>
    );
}

const renderPnr = (pnrs) => {
    return pnrs.map((pnr) => `${pnr}`).join(", ");
}

// Reusable section component with independent expand behavior
const NotificationSection = ({ 
    title, 
    isSelected,
    onSelect, 
    isExpanded, 
    onExpandChange,
    contentDisabled = false,
    children,
    showExpandIcon = true,
    radioValue = null,
}) => {

    return (
        <>
            <Row style={{ display: 'flex', alignItems: 'center' }}>
                <Col flex="auto">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        
                        <Radio 
                            checked={isSelected}
                            disabled={contentDisabled}
                            onChange={() => onSelect(radioValue)}
                            value={radioValue}
                            className="custom-radio-fix"
                        >
                            <span style={{ verticalAlign: 'middle' }}>{title}</span>
                        </Radio>
                        {showExpandIcon && (
                            <div 
                                onClick={onExpandChange}
                                style={{ cursor: 'pointer', paddingLeft: 16}}
                            >
                                {isExpanded ? <UpOutlined /> : <DownOutlined />}
                            </div>
                        )}
                    </div>
                </Col>
            </Row>
            {isExpanded && children}
            <Divider style={{ marginTop: 5, marginBottom: 5 }}/>
        </>
    );
};

// Content component for SMS templates
const TemplateContent = ({ template }) => {
    if(!isValid(template)) return null;
    
    // Remove %0a characters from the template
    const cleanTemplate = template.replace(/%0a/g, ' ');
    
    return (
        <Row>
            <Col span={24} style={{ marginLeft: 24, marginTop: 8 }}>
                <p>{cleanTemplate}</p>
            </Col>
        </Row>
    );
};

// Input fields for delay notifications
const Inputs = ({ 
    minutes, 
    setMinutes, 
    contactNumber, 
    setContactNumber, 
    otherReason, 
    setOtherReason, 
    showReasonInput,
    label="Delay",
    showContactInput=true
}) => {
    return (
        <Row>
            <Col span={24} style={{ marginLeft: 24, marginTop: 8 }}>
                <>
                    {showReasonInput && (
                        <Row gutter={[16, 8]}>
                            <Col>
                                <Text>Reason: </Text>
                                <Input 
                                    style={{ width: 150 }}
                                    value={otherReason}
                                    onChange={(e) => setOtherReason(e.target.value)}
                                    placeholder="Enter reason"
                                />
                            </Col>
                        </Row>
                    )}
                    <Row gutter={[16, 8]} style={{ marginTop: 8 }}>
                        <Col>
                            <Text>{label} Minutes: </Text>
                            <Input 
                                style={{ width: 60 }}
                                value={minutes}
                                onChange={(e) => setMinutes(e.target.value)}
                            />
                        </Col>
                        {showContactInput&&
                            <Col>
                                <Text>Contact: </Text>
                                <Input 
                                    style={{ width: 120 }}
                                    value={contactNumber}
                                    onChange={(e) => setContactNumber(e.target.value)}
                                />
                            </Col>
                        }
                    </Row>
                </>
            </Col>
        </Row>
    );
};

export const NotifyComponent = (props) => {
    const { pnrs = [], travelDate = "", onCancel = () => {},showCancelBtn = true,notifyModalVisible = false,tripId = null,sentLocation = null,showPnrs = false } = props;

    const {
        isMobile
    }=useContext(DeviceContext);
    // Single radio selection state
    const [selectedOption, setSelectedOption] = useState(null);

    const effectivePnrs = pnrs;
    
    // Input field states
    const [otherReasonsText, setOtherReasonsText] = useState("");
    const [minutes, setMinutes] = useState(30);
    const [contactNumber, setContactNumber] = useState("");
    
    // Expansion states
    const [ticketDetailsExpanded, setTicketDetailsExpanded] = useState(false);
    const [trackingDetailsExpanded, setTrackingDetailsExpanded] = useState(false);
    const [remainderExpanded, setRemainderExpanded] = useState(false);
    const [breakdownExpanded, setBreakdownExpanded] = useState(false);
    const [trafficJamExpanded, setTrafficJamExpanded] = useState(false);
    const [rainfallExpanded, setRainfallExpanded] = useState(false);
    const [otherReasonsExpanded, setOtherReasonsExpanded] = useState(false);
    const [earlyTimeExpanded, setEarlyTimeExpanded] = useState(false);
    
    const [templates, setTemplates] = useState([]);
    
    const dispatch = useDispatch();
    
    const setLoading = (value) => {
        dispatch(loadingAction(value));   
    };
    
    // Helper function to get template content by type
    const getTemplateContent = (type) => {
        if (!isValidArray(templates)) return "";
        const template = templates.find(t => t.sms_type === type);
        return template ? template.sms_content : "";
    };
    
    // Helper function to format template content with data
    const getFormattedContent = (content, data = {}) => {
        let formatted = content;
        Object.keys(data).forEach(key => {
            formatted = formatted.replaceAll(`$${key}`, data[key]);
        });
        return formatted;
    };
    
    // Handle option selection and expand relevant section
    const handleOptionSelect = (value) => {
        setSelectedOption(value);
        
        // Expand only the selected section
        setTicketDetailsExpanded(value === 'ticketDetails');
        setTrackingDetailsExpanded(value === 'drivingDetails');
        setRemainderExpanded(value === 'remainder');
        setBreakdownExpanded(value === 'vehicleBreakdown');
        setTrafficJamExpanded(value === 'trafficJam');
        setRainfallExpanded(value === 'rainfall');
        setOtherReasonsExpanded(value === 'otherReasons');
    };
    
    // Load SMS templates on component mount
    useEffect(() => {
        if (!isValidArray(templates) || templates.length === 0) {  
            getSmsTemplates(
                (data) => setTemplates(data),
                (errMsg) => message.error(errMsg)
            );
        }
    }, []);
    
    
    const prepareSmsData = (isSMS = true) => {
        let smsData = null;
        
        switch(selectedOption) {
            case 'ticketDetails':
                smsData = {
                    type: "isTicketDetails",
                    message: getTemplateContent("REMAINDER_SMS_CONTENT"),
                    isSMS: isSMS,
                    isEmail: !isSMS
                };
                break;
                
            case 'drivingDetails':
                smsData = {
                    type: "isTrackingDetails",
                    message: "Tracking details will appear here",
                    isSMS: isSMS,
                    isEmail: !isSMS
                };
                break;
                
            case 'remainder':
                smsData = {
                    type: "isRemainder",    
                    message: getTemplateContent("REMAINDER_SMS_CONTENT"),
                    isSMS: isSMS,
                    isEmail: !isSMS
                };
                break;
                
            case 'vehicleBreakdown':
                smsData = {
                    type: "isVehicleBreakdown",
                    message: getFormattedContent(getTemplateContent("VEHICLE_BREAKDOWN_SMS_CONTENT"), {
                        PASSENGER_NAME: "Passenger",
                        OPERATOR_NAME: global.operatorName,
                        TRAVEL_DATE: getDateMonthYearInReadable(travelDate),
                    }),
                    isSMS: isSMS,
                    isEmail: !isSMS
                };
                break;
                
            case 'trafficJam':
                smsData = {
                    type: "isTrafficJam",
                    message: getFormattedContent(getTemplateContent("BUS_DELAY_SMS_CONTENT"), {
                        REASON: "Traffic Jam in city",
                        MINUTES: minutes,
                        CONTACT_NO: contactNumber,
                        OPERATOR_NAME: global.operatorName
                    }),
                    isSMS: isSMS,
                    isEmail: !isSMS
                };
                break;
                
            case 'rainfall':
                smsData = {
                    type: "isRainfall",
                    message: getFormattedContent(getTemplateContent("BUS_DELAY_SMS_CONTENT"), {
                        REASON: "Heavy Rainfall in city",
                        MINUTES: minutes,
                        CONTACT_NO: contactNumber,
                        OPERATOR_NAME: global.operatorName
                    }),
                    isSMS: isSMS,
                    isEmail: !isSMS
                };
                break;

            case 'earlytime':
                smsData = {
                    type: "isEarlyTime",
                    message: getFormattedContent(getTemplateContent("EARLY_TIME_SMS_CONTENT"), {
                        EARLY_TIME: minutes,
                        OPERATOR_NAME: global.operatorName
                    }),
                    isSMS: isSMS,
                    isEmail: !isSMS
                };
                break;

            case 'otherReasons':
                smsData = {
                    type: "isOtherReason",
                    message: getFormattedContent(getTemplateContent("BUS_DELAY_SMS_CONTENT"), {
                        REASON: otherReasonsText || "unavoidable circumstances",
                        MINUTES: minutes,
                        CONTACT_NO: contactNumber,
                        OPERATOR_NAME: global.operatorName
                    }),
                    isSMS: isSMS,
                    isEmail: !isSMS
                };
                break;
                
            default:
                // No option selected
                break;
        }
        
        return {
            pnrs: effectivePnrs,
            smsData: smsData
        };
    };

    if(!notifyModalVisible) return null;

    // If no PNRs, show a message
    if (!isValidArray(effectivePnrs) || effectivePnrs.length === 0) {
        return <div>No tickets to notify</div>;
    }

    return (
        <div>
            {showPnrs&&
            <div>
                <Text>
                    { `Ticket info for PNR `}
                    <Text strong>{renderPnr(effectivePnrs)}</Text>
                    { ` is going to be sent.`}
                </Text>
                <Divider />
            </div>
            }
            <Row>
                <Col span={24}>
                    <div style={{ marginBottom: 16 }}>
                        <Text strong>Select Notification Type:</Text>
                    </div>
                        {/* Ticket Details Section */}
                        <NotificationSection
                            title="Ticket Details"
                            isSelected={selectedOption === 'ticketDetails'}
                            onSelect={handleOptionSelect}
                            isExpanded={ticketDetailsExpanded}
                            onExpandChange={() => setTicketDetailsExpanded(!ticketDetailsExpanded)}
                            showExpandIcon={false}
                            radioValue="ticketDetails"
                        >
                            <TemplateContent 
                                template={null}
                            />
                        </NotificationSection>
                        
                        {/* Tracking Details Section */}
                        <NotificationSection
                            title="Send Tracking Details"
                            isSelected={selectedOption === 'drivingDetails'}
                            onSelect={handleOptionSelect}
                            isExpanded={trackingDetailsExpanded}
                            onExpandChange={() => setTrackingDetailsExpanded(!trackingDetailsExpanded)}
                            showExpandIcon={false}
                            radioValue="drivingDetails"
                        >
                            <TemplateContent 
                                template={null}
                            />
                        </NotificationSection>
                        
                        {/* Remainder Section */}
                        <NotificationSection
                            title="Send Remainder"
                            isSelected={selectedOption === 'remainder'}
                            onSelect={handleOptionSelect}
                            isExpanded={remainderExpanded}
                            onExpandChange={() => setRemainderExpanded(!remainderExpanded)}
                            showExpandIcon={false}
                            radioValue="remainder"
                        >
                            <TemplateContent 
                                template={null}
                            />
                        </NotificationSection>
                        
                        {/* Vehicle Breakdown Section */}
                        <NotificationSection
                            title="Vehicle Breakdown"
                            isSelected={selectedOption === 'vehicleBreakdown'}
                            onSelect={handleOptionSelect}
                            isExpanded={breakdownExpanded}
                            onExpandChange={() => setBreakdownExpanded(!breakdownExpanded)}
                            showExpandIcon={true}
                            radioValue="vehicleBreakdown"
                        >
                            <TemplateContent 
                                template={getFormattedContent(getTemplateContent("VEHICLE_BREAKDOWN_SMS_CONTENT"),{
                                    PASSENGER_NAME:"Passenger",
                                    OPERATOR_NAME: global.operatorName,
                                    TRAVEL_DATE : getDateMonthYearInReadable(travelDate),
                                })}
                            />
                        </NotificationSection>
                        
                        {/* Traffic Jam Section */}
                        <NotificationSection
                            title="Traffic Jam - Bus Delay"
                            isSelected={selectedOption === 'trafficJam'}
                            onSelect={handleOptionSelect}
                            isExpanded={trafficJamExpanded}
                            onExpandChange={() => setTrafficJamExpanded(!trafficJamExpanded)}
                            showExpandIcon={true}
                            radioValue="trafficJam"
                        >
                            <TemplateContent 
                                template={getFormattedContent(getTemplateContent("BUS_DELAY_SMS_CONTENT"), {
                                    REASON: "Traffic Jam in city",
                                    MINUTES: minutes,
                                    CONTACT_NO: contactNumber,
                                    OPERATOR_NAME: global.operatorName
                                })}
                            />
                            <Inputs 
                                minutes={minutes}
                                setMinutes={setMinutes}
                                contactNumber={contactNumber}
                                setContactNumber={setContactNumber}
                                showReasonInput={false}
                            />
                        </NotificationSection>
                        <NotificationSection
                            title="Early time"
                            isSelected={selectedOption === 'earlytime'}
                            onSelect={handleOptionSelect}
                            isExpanded={earlyTimeExpanded}
                            onExpandChange={() => setEarlyTimeExpanded(!earlyTimeExpanded)}
                            showExpandIcon={true}
                            radioValue="earlytime"
                        >
                            <TemplateContent 
                                template={getFormattedContent(getTemplateContent("EARLY_TIME_SMS_CONTENT"), {
                                    EARLY_TIME: minutes,
                                    OPERATOR_NAME: global.operatorName
                                })}
                            />
                            <Inputs 
                                minutes={minutes}
                                setMinutes={setMinutes}
                                showReasonInput={false}
                                showContactInput={false}
                                label="Early"
                            />
                        </NotificationSection>
                        {/* Rainfall Section */}
                        <NotificationSection
                            title="Rainfall - Bus Delay"
                            isSelected={selectedOption === 'rainfall'}
                            onSelect={handleOptionSelect}
                            isExpanded={rainfallExpanded}
                            onExpandChange={() => setRainfallExpanded(!rainfallExpanded)}
                            showExpandIcon={true}
                            radioValue="rainfall"
                        >
                            <TemplateContent 
                                template={getFormattedContent(getTemplateContent("BUS_DELAY_SMS_CONTENT"), {
                                    REASON: "Heavy Rainfall in city",
                                    MINUTES: minutes,
                                    CONTACT_NO: contactNumber,
                                    OPERATOR_NAME: global.operatorName
                                })}
                            />
                            <Inputs 
                                minutes={minutes}
                                setMinutes={setMinutes}
                                contactNumber={contactNumber}
                                setContactNumber={setContactNumber}
                                showReasonInput={false}
                            />
                        </NotificationSection>
                        
                        {/* Other Reasons Section */}
                        <NotificationSection
                            title="Other Reasons - Bus Delay"
                            isSelected={selectedOption === 'otherReasons'}
                            onSelect={handleOptionSelect}
                            isExpanded={otherReasonsExpanded}
                            onExpandChange={() => setOtherReasonsExpanded(!otherReasonsExpanded)}
                            showExpandIcon={true}
                            radioValue="otherReasons"
                        >
                            <TemplateContent 
                                template={getFormattedContent(getTemplateContent("BUS_DELAY_SMS_CONTENT"), {
                                    REASON: otherReasonsText || "unavoidable circumstances",
                                    MINUTES: minutes,
                                    CONTACT_NO: contactNumber,
                                    OPERATOR_NAME: global.operatorName
                                })}
                            />
                            <Inputs 
                                minutes={minutes}
                                setMinutes={setMinutes}
                                contactNumber={contactNumber}
                                setContactNumber={setContactNumber}
                                otherReason={otherReasonsText}
                                setOtherReason={setOtherReasonsText}
                                showReasonInput={true}
                            />
                        </NotificationSection>
                    
                    {/* Action Buttons */}
                    <Row gutter={[16,16]}>
                        {showCancelBtn && (
                            <Col>
                                <Button
                                    size="large"
                                    onClick={() =>{
                                        onCancel();
                                    }}
                                    className="exit-btn"
                                >
                                    Cancel
                                </Button>
                            </Col>
                        )}
                        <Col>
                            <Button
                                size="large"
                                icon={<MobileOutlined />}
                                disabled={!selectedOption}
                                onClick={() => {
                                    if (!selectedOption) {
                                        message.warning("Please select a notification type");
                                        return;
                                    }
                                    setLoading(true);
                                    const formattedData = prepareSmsData(true);
                                    sendSms(formattedData,tripId,sentLocation,
                                        (data) => {
                                            message.success("SMS sent successfully");
                                            setLoading(false);
                                        },
                                        (errMsg) => {
                                            console.error("Failed to send SMS:", errMsg);
                                            message.error("Failed to send SMS");
                                            setLoading(false);
                                        }
                                    );
                                }}
                            >
                                Send SMS
                            </Button>
                        </Col>
                        {getEmailEnabled(selectedOption) && (
                            <Col>
                                <Button
                                    size="large"
                                icon={<MailOutlined />}
                                onClick={() => {
                                    const formattedData = prepareSmsData(false);
                                    setLoading(true);
                                    sendSms(formattedData,tripId,sentLocation,
                                        (data) => {
                                            message.success("Email sent successfully");
                                            console.log("Email sent successfully:", data);
                                            setLoading(false);
                                        },
                                        (errMsg) => {
                                            console.error("Failed to send SMS:", errMsg);
                                            message.error("Failed to send Email");
                                            setLoading(false);
                                        }
                                    );
                                }}
                            >
                                Send Email
                            </Button>
                        </Col>
                        )}
                        {getWhatsAppEnabled(selectedOption,effectivePnrs) && (
                        <Col>
                            <Button
                                size="large"
                                className="whatsapp-share-btn"
                                icon={<WhatsAppOutlined />}
                                onClick={() => {
                                    setLoading(true);
                                    fetchTicketDetailsByPNR(effectivePnrs[0], (data) => {
                                        const whatsappMessage = getTextOfTicket(data);
                                        const whatsappUrl =getWhatsAppMessage(isMobile,data.ticket.phone_number,whatsappMessage);
                                        window.open(whatsappUrl, '_blank'); 
                                        setLoading(false);
                                    },(errMsg)=>{
                                        console.error("Failed to fetch ticket details:", errMsg);
                                        message.error("Failed to share on WhatsApp");
                                        setLoading(false);
                                    });
                                }}
                            >
                                Share
                            </Button>
                        </Col>
                        )}
                    </Row>
                </Col>
            </Row>
        </div>
    );
}
